import * as m from "@paraglide/messages"
import type { SupportedLocale } from "@playbrain/content-types"

/**
 * An inline reader for a PDF.
 *
 * Deliberately the browser's own viewer in an <object>, not pdf.js: every
 * desktop browser ships one, it costs no bundle, and it renders the report at
 * full fidelity without us maintaining a renderer.
 *
 * The download link is not a fallback bolted on — it is the whole interface on
 * a phone. Mobile Safari and Android Chrome do not render an embedded PDF;
 * they show nothing, or a blank box. So the frame is hidden below the tablet
 * breakpoint and the link carries the page there, which is also what the live
 * site does everywhere. <object> is what makes that switch reliable: unlike an
 * <iframe> it renders its children when it cannot render the resource.
 */
export function PlaydataPdfViewer({
  locale,
  title,
  url,
}: {
  locale: SupportedLocale
  title: string
  url: string
}) {
  return (
    <div className="w-full">
      <object
        aria-label={title}
        className="hidden h-[70vh] max-h-[900px] min-h-[480px] w-full rounded-[5.2px] border border-[#d5d5d5] md:block"
        data={url}
        type="application/pdf"
      >
        <p className="p-[2.4rem] text-center text-[1.4rem]">
          {m.playdata_sample_viewerFallback({}, { locale })}
        </p>
      </object>
    </div>
  )
}
